import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/mevcut.webp")